import config from '../config';
import { clampTextToDimensions } from '../utils';

let soundManager;
let dataManager;

class Score extends Phaser.Scene {
  init (data) {
    let g = this;
    g.transitionActive = true;
    soundManager = g.scene.get('SoundManager');
    dataManager = g.sys.game.dataManager;
    // console.log('Set beeMoneyCount', 0);
    dataManager.setSessionItem('beeMoneyCount', 0);
    dataManager.setSessionItem('continueAvailable', true);

    dataManager.checkHighScore();

    g.fadeBg = !!data.fadeBg;

    if (g.fadeBg) {
      soundManager.playMusic('loop-end');
      dataManager.saveCoins();
      g.scene.pause(dataManager.getSessionItem(config.BASE_SCENE));
    }
  }
  create () {
    let g = this;

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      console.log('On Score Resume!');
      soundManager.resumeMusic();
    });

    let bg = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'overlay-bg');
    bg.setAlpha(g.fadeBg ? 0 : 0.9);

    let group = [];
    let panelX = -config.WIDTH / 2;

    let panel = g.add.sprite(panelX, config.CENTER_Y + 100, 'score-sprite');
    panel.setFrame('window.png');
    group.push(panel);

    let body = g.add.sprite(panelX, panel.y - 266, 'score-sprite', 'body.png');
    group.push(body);

    let eyes = g.add.sprite(body.x, body.y, 'score-sprite');
    eyes.play('score-eyes');
    group.push(eyes);

    g.children.bringToTop(panel);
    
    let textGameOver = g.add.text(panelX, panel.y - 500, g.game.localisationManager.GetString("game_over"), { fontFamily: "FredBurger Black", fontSize: (76) +"px", color: "#FFF", align: 'center' })
    textGameOver.setOrigin(0.5);
    textGameOver.setStroke('#000', 12);
    clampTextToDimensions(textGameOver, g.scale.width, 100);
    group.push(textGameOver);
    
    let textFinal = g.add.text(panelX, panel.y - 170, g.game.localisationManager.GetString("final_score"), { fontFamily: "FredBurger Black", fontSize: (36) +"px", color: "#000", align: 'center' })
    textFinal.setOrigin(0.5);
    clampTextToDimensions(textFinal, 400, 100);
    group.push(textFinal);

    let scoreValue = dataManager.getScore();

    let score = g.add.text(panelX, panel.y - 95, g.game.localisationManager.language != "ar" ? scoreValue.toLocaleString(g.game.localisationManager.language) : scoreValue, { fontFamily: "FredBurger Black", fontSize: (94) +"px", color: "#ffef00", align: 'center' })
    score.setOrigin(0.5);
    score.setStroke('#000', 12);
    clampTextToDimensions(score, 400, 200);
    group.push(score);
    
    let textBest = g.add.text(panelX, panel.y - 10, g.game.localisationManager.GetString("best"), { fontFamily: "FredBurger Black", fontSize: (32) +"px", color: "#000", align: 'center' })
    textBest.setOrigin(0.5);
    clampTextToDimensions(textBest, 400, 100);
    group.push(textBest);

    let bestValue = dataManager.getHighScore();
    
    let best = g.add.text(panelX, panel.y + 30, g.game.localisationManager.language != "ar" ? bestValue.toLocaleString(g.game.localisationManager.language) : bestValue, { fontFamily: "FredBurger Black", fontSize: (44) +"px", color: "#000", align: 'center' })
    best.setOrigin(0.5);
    clampTextToDimensions(best, 400, 100);
    group.push(best);

    let coin = g.add.sprite(panelX - 13, panel.y + 120, 'score-sprite');
    coin.setFrame('coin.png');
    coin.setOrigin(1, 0.5);
    group.push(coin);

    let coinValue = dataManager.getCoins();
    
    let coinCount = g.add.text(panelX - 13, coin.y, g.game.localisationManager.language != "ar" ? coinValue.toLocaleString(g.game.localisationManager.language) : coinValue, { fontFamily: "FredBurger Black", fontSize: (44) +"px", color: "#fcbd19", align: 'center' })
    coinCount.setOrigin(0, 0.5);
    coinCount.setStroke('#FFF', 12);
    group.push(coinCount);

    let btnPlay = g.add.sprite(panelX, panel.y + 254, 'score-sprite');
    btnPlay.setFrame('btn-play.png');
    btnPlay.setInteractive();
    btnPlay.on('pointerdown', () => {
      if (g.transitionActive) { return; }
      soundManager.playSound('btn-play');
      g.transitionActive = true;
      g.tweens.add({
        targets: group,
        x: '+=' + config.WIDTH,
        duration: 250,
        ease: 'Quad.easeOut',
        onComplete: () => {
          g.scene.stop('Score');
          g.scene.launch('Store');
          // g.scene.stop('Play');
          // g.scene.start('Play', { isContinue: false, queuedPause: false });
        }
      });
    });
    group.push(btnPlay);

    if (g.fadeBg) {
      g.tweens.add({
        targets: bg,
        alpha: 0.9,
        duration: 250
      });
    }
    g.tweens.add({
      targets: group,
      x: '+=' + config.WIDTH,
      duration: 500,
      ease: 'Back.easeOut',
      onComplete: () => {
        g.transitionActive = false;
        let score = dataManager.getScore();
        g.time.delayedCall(500, () => {
          if (score >= config.SCORE_GREAT) {
            soundManager.playSound('vo-gameover-great');
          } else if (score >= config.SCORE_MEDIUM) {
            soundManager.playSound('vo-gameover-poor');
          } else {
            soundManager.playSound('vo-gameover-poor');
          }
        });
      }
    });
  }
}

export default Score;
